import { Product } from '../contexts/AppContext';
import { DispatchActions } from '../enums/DispatchActions';

const products: Product[] = [
	{
		id: 1,
		path: '/images/pork_siomai.png',
		itemName: 'Pork Siomai',
		code: 'PRKSMI',
		description:
			'Dumplings of ground meat and spices served with a special soy-based dipping sauce on request. Can be steamed or fried.',
		price: 20,
		quantity: 1,
	},
	{
		id: 2,
		path: '/images/fried_siomai.png',
		itemName: 'Fried Siomai',
		code: 'FRDSMI',
		description:
			'Made from juicy pork filling with the right amount of pork bits and other spices, wrapped in crispy paper and deep fried to its golden color.',
		price: 30,
		quantity: 1,
	},
	{
		id: 3,
		path: '/images/chicken_siomai.png',
		itemName: 'Chicken Siomai',
		code: 'CHKSMI',
		description:
			'A classic favorite steam food, made of delicious steamed pork meatball wrapped in soft molo wrapper. Best enjoyed with our Chili Garlic Sauce.',
		price: 40,
		quantity: 1,
	},
];

export const initialState = {
	products,
	openCart: false,
	cart: [],
	totalAmount: 0,
};

export const reducer = (state: any, action: any) => {
	// action = {type, payload}

	switch (action.type) {
		case DispatchActions.OPEN_CART:
			return {
				...state,
				openCart: true,
			};
		case DispatchActions.CLOSE_CART:
			return {
				...state,
				openCart: false,
			};
		case DispatchActions.ADD_TO_CART:
			return {
				...state,
				cart: [...state.cart, action.payload],
			};
		case DispatchActions.UPDATE_CART:
			return {
				...state,
				cart: action.payload,
			};
		case DispatchActions.UPDATE_TOTAL_AMOUNT:
			const updatedTotalAmount = state.cart.reduce(
				(acc: number, curr: Product) => acc + curr.price * curr.quantity,
				0
			);

			return {
				...state,
				totalAmount: updatedTotalAmount,
			};
		default:
			return state;
	}
};
